import { rbacCapabilityCheckAllOf } from '@libs/rbac/functions'
import { deny, grant } from '@libs/rbac/permissions'
import type { RbacCapabilityCheck } from '@libs/rbac/types'

/**
 * Main permission allowing to show AzureAD data or not.
 */
export const canDisplayAzureAdBecauseEnabled: RbacCapabilityCheck = (
  rbacPermissions,
  meta
) => {
  const { azureADSupportConfiguration } =
    meta.storeRbac.storeRoot.stores.storeManagementAzureAD

  const { isLicenseUpToDate } = meta.storeRbac.storeRoot.stores.storeLicense

  return rbacCapabilityCheckAllOf(
    // Is the license up-to-date?
    isLicenseUpToDate ? grant() : deny(),
    // Is the feature enabled?
    azureADSupportConfiguration?.azureADSupportEnabled ? grant() : deny()
  )(rbacPermissions, meta)
}
